// slices/LoadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const SidebarDataLoadingSlice = createSlice({
  name: 'sidebarDataLoading',
  initialState: {
    isLoading: false,
    loadingMessage: ''
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload.isLoading;
    //   state.loadingMessage = action.payload.message || '';
    }
  }
});

export const { setLoading } = SidebarDataLoadingSlice.actions;
export default SidebarDataLoadingSlice.reducer;